import React, {useCallback, useContext} from 'react';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import {Props} from '@src/components/Form/FormField';
import OrderProductsChecklists from '@views/orders/fields/products/extra_row/OrderProductsChecklists';
import ChecklistFilter from '@views/orders/ChecklistFilter';
import {FormTabsContext} from '@src/contexts/FormTabsContext';

const emptyArray: never[] = [];

export default function ChecklistsTab<Model extends IOrderModel = IOrderModel>(props: Props<Model>) {
    const {tabName} = props;
    const tabContext = useContext(FormTabsContext);
    const toggleTabVisibility = useCallback((state: boolean) => {
        if (tabName && tabContext) {
            tabContext.changeVisibility(tabName, state);
        }
    }, [tabContext, tabName]);

    if (!props.model?.order_id || !props.model?.id || !props.model?.status_id) {
        return null;
    }

    return <ChecklistFilter
            productId={props.model.product_id}
            checklists={props.modelOptions?.checklists ?? emptyArray}
            currentStatusId={props.model?.status_id as number}
            displayOnlyWithType="for-order-product"
            toggleTabVisibility={toggleTabVisibility}
    >{() => {
        return <OrderProductsChecklists<IOrderModel>
                orderId={props.model?.order_id}
                entityStatusId={props.model?.status_id as number}
                checkedItems={props.model?.checked_checklists_items}
                model={props.model as any}
                modelOptions={props.modelOptions}
                rowRecord={props.model as any}
                isDisabled={props.forceDisabled}
        />;
    }}</ChecklistFilter>;
}
